export const REGEXP_PP_ITEM_VALUE = "^([0-9,]+)$";
export const POST_CODE =
  "^(?![Ii][Mm])(?![Jj][Ee])(?![Gg][Yy])[A-Za-z]{1,2}[0-9A-Za-z]{1,2}\\s?[0-9][A-Za-z]{2}$";
export const NUMBER_ONLY_REGEX = "^[0-9]+$";
export const NAME_REGEX = "^[a-zA-Z][a-zA-Z-'\\s]*$";
export const DATE_REGEX = "^\\s*$|^(\\d{2})\\/(\\d{2})\\/\\d{4}$";
export const FIRST_NUMBER_CHARACTERS_REGEX = "^[0-9,]+(.[0-9]{1,2})?$";
export const FOUR_DIGIT_NUMBER_PATTERN = "^\\d{4}$";
export const ALPHANUMERIC_AND_SPECIAL_CHARS_PATTERN =
  "^[a-zA-Z0-9\\s\\-\\'\\,\\.\\/]*$";
export const EMAIL_REGEX =
  "^[\\w\\-\\.\\+]+\\@[a-zA-Z0-9\\.\\-]+\\.[a-zA-z0-9]{2,}$";
export const TEXT_ONLY_REGEX = "^[a-zA-Z&\\s-]*$";
export const SORT_CODE_REGEX = "^^[0-9\\-]*$";
export const USER_REF_EXCLUDE_ANGLE_BRACKETS_REGEX = "^[^<>]*$";
export const CURRENCY_REGEX = "^[0-9,]+(.[0-9]{1,2})?$";
export const MONEY_REGEX = "^\\d*(\\.\\d{1,2})?(\\.\\d{2})?$";
export const CAPITALIZE_LETTER_LIST_ITEMS_REGEX = /(^\w|\/\s*\w)/g;
